// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"ab363458","977":"63ad852d"}[chunkId] + ".chunk.js";
};